{
  "comment": "M7 spec §6 and §7 (S13 owns; read by src/story/okafor.ts and src/story/hale.ts). okafor.hideout: the anchor whose relay and lane-ring jobs never reach a generic contract board before story tier genericJobsFromTier (W5), and the M3 step ids the risk reads (the relay repair, the hideout dock, the testimony). okafor.risk: Okafor's risk starts once the relay is repaired and Mission 3 is active (or the hideout was docked); warningOnlineDays [min, max] online faction days later the Wire reports survey traffic and Kell warns; custodyOnlineDays [min, max] more online days later Tethys takes him if he is still at the hideout (never killed; countdowns pause offline); lostOnlineDays after custody with no rescue he is lost for good and his lab notes remain. The day counts are drawn per career from the career seed. kellMinHoldfast: Kell gives the mission at Holdfast standing ≥ this, otherwise the Mutual Bulletin lead does. okafor.trust: the trust step accepts a meter reading of a Tethys operation taken within readingWindowDays faction days, the player's records (at least minTetherSales tetherstone sales) or the Watch history (any of watchLogs held); with none and no Tethys rig in the Reach the mission asks for one rig as mission-owned traffic (rigKey, in rigSystem). okafor.rescue: the prisoner transport (a ship on a scheduled route, never a dock). hale: the bounty faction the deal wipes and a voided deal restores, the Holdfast claim id that faces the registry challenge when the deal is voided, the bounty Hale's enmity seeds if the player refused and later exposes, and the founding fee comes from strategic/corp.json founding.fee. Nodes are comms ids (comms/m3.json, comms/m4.json); Wire headlines are ids. Placeholders for the balance pass (M7 spec §15 item 4); tune freely.",
  "okafor": {
    "kellMinHoldfast": 0,
    "hideout": {
      "anchor": "okafor-hideout",
      "genericJobsFromTier": 3,
      "relayStep": "relay",
      "dockStep": "meet",
      "trustStep": "trust",
      "reportStep": "report"
    },
    "risk": {
      "warningOnlineDays": [3, 5],
      "custodyOnlineDays": [5, 8],
      "lostOnlineDays": 15
    },
    "trust": {
      "readingWindowDays": 20,
      "minTetherSales": 1,
      "watchLogs": ["watch.book_seven", "watch.corr_meter_reading"],
      "node": "m3.okafor.trust",
      "askReply": "show",
      "proofReply": "proof",
      "rigKey": "m3:rig",
      "rigSystem": "okafor-hideout"
    },
    "rescue": {
      "transportKey": "m3:prisoner-transport",
      "transportSystem": "megacorp-hq",
      "leaveNode": "m3.kell.custody",
      "leaveReply": "leave"
    },
    "comms": {
      "proven": "m3.okafor.reading",
      "noProof": "m3.okafor.no_proof",
      "noRig": "m3.okafor.no_rig",
      "held": "m3.okafor.not_here",
      "warning": "m3.kell.warning",
      "custody": "m3.kell.custody",
      "rescued": "m3.okafor.rescued",
      "lost": "m3.kell.lost",
      "bulletinOffer": "m3.bulletin.offer"
    },
    "wire": {
      "warning": { "headline": "m3.relay_lane_survey", "severity": 1, "source": "mutualBulletin" },
      "custody": { "headline": "m3.hideout_detention", "severity": 1, "source": "candleRelay" }
    }
  },
  "hale": {
    "bountyFaction": "authority",
    "holdfastClaimId": "holdfast-generational",
    "enmityBounty": 20000,
    "dealFork": "deal",
    "takeChoice": "take",
    "comms": {
      "voided": "m4.hale.voided"
    },
    "wire": {
      "audit": { "headline": "m4.relay_crew_audited", "severity": 1, "source": "mutualBulletin" },
      "voided": { "headline": "m4.hale_deal_voided", "severity": 2, "source": "authorityGazette" }
    }
  }
}
